const STORAGE_KEY = 'yokoso_web3_mode'

/**
 * Web3 (JPYC) モードを使ってよい環境か。**純関数**（env を引数で受ける）にしてあるのは、
 * ビルド時定数の import.meta.env を差し替えられないため — 判定そのものは
 * node で直接検査する (docs/verification/web3-prod-gate-1740/)。
 *
 * #1740 JPYC は Sepolia の TestJPYC で動かしている実験機能で、**本番に on-chain の
 * 決済経路は無い** (API は #1732 で prod の /charge/execute・/payment/record・
 * /payment/execute を 404 にした)。フロントだけ入れてしまうと、wallet / charge / pay
 * の画面が出て、pay() は on-chain 送金を先に実行してから /payment/record の 404 で
 * 「支払いに失敗しました」になる。価値の無いトークンとはいえ、**送金してから失敗
 * する体験**を本番で作らない。
 *
 * prod で実チェーンに載せる日が来たら、VITE_NETWORK をメインネットにする変更と
 * 一緒にここを開ける (テストネットの列挙で判定するのは、知らない値が来たときに
 * 開かないように = fail-closed)。
 */
export function web3AllowedFor(appEnv: string | undefined, network: string | undefined): boolean {
  // #2140 体験専用の環境 (trial) も本番と同じく閉じる (誰でも使う公開の環境)
  const env = (appEnv || '').trim().toLowerCase()
  if (env !== 'prod' && env !== 'trial') return true
  const mainnets = new Set(['polygon', 'ethereum', 'mainnet'])
  return mainnets.has((network || '').trim().toLowerCase())
}

function web3Allowed(): boolean {
  return web3AllowedFor(
    import.meta.env.VITE_APP_ENV as string | undefined,
    import.meta.env.VITE_NETWORK as string | undefined,
  )
}

/**
 * Initialize auth mode from URL parameter.
 * Call once on app startup (Splash.tsx).
 * ?web3=true → Web3Auth + JPYC mode
 * default   → Firebase Auth + Stripe mode
 *
 * #1740 本番 (テストネット構成) では ?web3=true を無視する。
 */
export function initAuthMode(searchParams: URLSearchParams): void {
  const web3Param = searchParams.get('web3')
  if (web3Param === 'true' && web3Allowed()) {
    sessionStorage.setItem(STORAGE_KEY, 'true')
  }
}

/** True when running in Web3Auth + JPYC mode */
export function isWeb3Mode(): boolean {
  // 既に sessionStorage に立っていても (gate 導入前のタブ)、本番では false
  return web3Allowed() && sessionStorage.getItem(STORAGE_KEY) === 'true'
}
